import { AfterViewInit, DestroyRef, Directive, ElementRef, inject } from '@angular/core';

@Directive({
  selector: '[sticky]',
  standalone: false,
  host: { class: 'title-sticky' }
})
export class Sticky implements AfterViewInit {
  private el = inject<ElementRef<HTMLElement>>(ElementRef);
  private destroyRef = inject(DestroyRef);

  private ro?: ResizeObserver;
  private static raf = 0;

  ngAfterViewInit() {
    // observe la hauteur (utile si l'entête wrap / change)
    this.ro = new ResizeObserver(() => Sticky.recompute());
    this.ro.observe(this.el.nativeElement);

    Sticky.recompute();

    const onResize = Sticky.recompute;
    window.addEventListener('resize', onResize, { passive: true });

    this.destroyRef.onDestroy(() => {
      this.ro?.disconnect();
      window.removeEventListener('resize', onResize);
      Sticky.recompute();
    });
  }

  static recompute = () => {
    cancelAnimationFrame(Sticky.raf);
    Sticky.raf = requestAnimationFrame(() => {
      const headers = Array.from(document.querySelectorAll<HTMLElement>('[sticky]'));
      let offset = 0;

      for (const h of headers) {
        h.style.top = `${offset}px`; // <= empilement
        offset += h.getBoundingClientRect().height;
      }
    });
  };
}
